import {BaseClient} from '../utils/base-client';

class ERFExperimentsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    const workspaceOrProject = workspaceId ? `workspaces/${workspaceId}` : `projects/${projectId}`;
    return `api/app/${workspaceOrProject}/experiments/erf/`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const erfExperimentsClient = new ERFExperimentsClient();
